import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash.get';

class ItemTitle extends React.Component {
    constructor(props) {
        super(props);

        this.title = null;
        this.addEllipses = this.addEllipses.bind(this);
        this.getTitle = this.getTitle.bind(this);
    }

    componentDidMount() {
        this.addEllipses();
    }

    addEllipses() {
        if (this.title) {
            this.title.innerHTML = this.getTitle();
            const maxTitleHeight = 120;
            while (this.title.clientHeight > maxTitleHeight) {
                this.title.innerHTML = this.title.innerHTML.replace(/\W*\s(\S)*$/, '...');
            }
        }
    }

    getTitle() {
        const { item } = this.props;
        const creationDate = get(item, 'classification.creationDate') || null;
        const creator = get(item, 'creators[0].creator.displayName') || null;
        const creatorLabel = creator ? ` by  ${creator}` : '';
        const creationDateLabel = creationDate ? `, ${creationDate}` : '';

        const { title = '', isArt } = item;

        return isArt ? `${title}${creatorLabel}${creationDateLabel}` : title;
    }

    render() {
        const title = this.getTitle();
        return (
            <div
                ref={titleEl => {
                    this.title = titleEl;
                }}
            >
                {title}
            </div>
        );
    }
}

ItemTitle.propTypes = {
    item: PropTypes.shape({
        classification: PropTypes.shape({
            creationDate: PropTypes.string,
        }),
        creators: PropTypes.arrayOf(
            PropTypes.shape({
                creator: PropTypes.shape({
                    displayName: PropTypes.string,
                }),
            })
        ),
        isArt: PropTypes.bool,
        title: PropTypes.string,
    }),
};

export default ItemTitle;
